export const AUTH_RECEIVE = 'AUTH_RECEIVE';
export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_ERROR = 'AUTH_ERROR';

export const AUTH_USER_RECEIVE = 'AUTH_USER_RECEIVE';
